// extracted by mini-css-extract-plugin
module.exports = {"is-1":"_7e4d33","is-2":"_fb377f"};